/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Roles_LeadInputs */

const en_mk_sec_pg_roles_lead = /** @type {(inputs: Mk_Sec_Pg_Roles_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Four roles, with no elaborate permission matrix. If you need finer control, that is among the things we have not built — and it is on the list below.`)
};

const id_mk_sec_pg_roles_lead = /** @type {(inputs: Mk_Sec_Pg_Roles_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empat peran, tanpa pengaturan izin yang rumit. Kalau Anda butuh kendali yang lebih halus, itu termasuk yang belum kami bangun — dan tertulis di daftar bawah.`)
};

/**
* | output |
* | --- |
* | "Four roles, with no elaborate permission matrix. If you need finer control, that is among the things we have not built — and it is on the list below." |
*
* @param {Mk_Sec_Pg_Roles_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_roles_lead = /** @type {((inputs?: Mk_Sec_Pg_Roles_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Roles_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_roles_lead(inputs)
	return en_mk_sec_pg_roles_lead(inputs)
});